export default __webpack_public_path__ + "static/media/book_image5.74bb514a.jfif";